import { createFileRoute } from "@tanstack/react-router";
import { GroupPreregistration } from "@/components/pre-registration/GroupPreregistration";
import { useTranslation } from "react-i18next";
import { useWelcomeVisitAccess } from "@/hooks/useWelcomeVisitAccess";
import { useLoggedInUser } from "@/store/zustandStore";
import { useBuildingWelcomeVisitAccess } from "@/hooks/useBuildingWelcomeVisitAccess";

export const Route = createFileRoute("/_portal/visitors/preregistration")({
  component: Preregistration,
});

function Preregistration() {
  const { t } = useTranslation();
  const currentUser = useLoggedInUser();
  useWelcomeVisitAccess(currentUser.buildingTenantId);
  useBuildingWelcomeVisitAccess();

  const breadcrumbs = [
    { label: t("SIDEBAR.VISITORS"), path: "/visitors" },
    {
      label: t("PAGES.VISITORS.PREREGISTRATION"),
      path: "/visitors/preregistration",
    },
  ];
  return <GroupPreregistration breadcrumbs={breadcrumbs} />;
}
